"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.setNextInputCommandAndRunIfNotAlreadyRunning = exports.setNextInputCommandAndRun = exports.setNextInputCommand = exports.getAndEatNextInputCommand = exports.EInputCommand = void 0;
var rogueMouseAreas_sidecar_1 = require("../monofont/rogueMouseAreas-sidecar");
var rogueGamepad_sidecar_1 = require("./rogueGamepad-sidecar");
var rogueKeyboard_sidecar_1 = require("./rogueKeyboard-sidecar");
var rogueMouse_sidecar_1 = require("./rogueMouse-sidecar");
var rogueMouseHandler_sidecar_1 = require("./rogueMouseHandler-sidecar");
var rogueRunMode_sidecar_1 = require("./rogueRunMode-sidecar");
var EInputCommand;
(function (EInputCommand) {
    EInputCommand[EInputCommand["none"] = 0] = "none";
    EInputCommand[EInputCommand["moveLeft"] = 1] = "moveLeft";
    EInputCommand[EInputCommand["moveRight"] = 2] = "moveRight";
    EInputCommand[EInputCommand["moveUp"] = 3] = "moveUp";
    EInputCommand[EInputCommand["moveDown"] = 4] = "moveDown";
    EInputCommand[EInputCommand["moveWait"] = 5] = "moveWait";
    EInputCommand[EInputCommand["select"] = 6] = "select";
    EInputCommand[EInputCommand["cancel"] = 7] = "cancel";
    EInputCommand[EInputCommand["openInventory"] = 8] = "openInventory";
    EInputCommand[EInputCommand["openMessages"] = 9] = "openMessages";
    EInputCommand[EInputCommand["openHelp"] = 10] = "openHelp";
    EInputCommand[EInputCommand["openStory"] = 11] = "openStory";
    EInputCommand[EInputCommand["openContextMenu"] = 12] = "openContextMenu";
    EInputCommand[EInputCommand["openCastMenu"] = 13] = "openCastMenu";
    EInputCommand[EInputCommand["openUpgradesMenu"] = 14] = "openUpgradesMenu";
    EInputCommand[EInputCommand["openLevelSelect"] = 15] = "openLevelSelect";
    EInputCommand[EInputCommand["openWinScreen"] = 16] = "openWinScreen";
    EInputCommand[EInputCommand["resetGame"] = 17] = "resetGame";
    EInputCommand[EInputCommand["debug"] = 18] = "debug";
    EInputCommand[EInputCommand["switchGraphics"] = 19] = "switchGraphics";
    EInputCommand[EInputCommand["zoomIn"] = 20] = "zoomIn";
    EInputCommand[EInputCommand["zoomOut"] = 21] = "zoomOut";
})(EInputCommand = exports.EInputCommand || (exports.EInputCommand = {}));
var _nextInputCommand = EInputCommand.none;
var getAndEatNextInputCommand = function () {
    var result = _nextInputCommand;
    _nextInputCommand = EInputCommand.none;
    return result;
};
exports.getAndEatNextInputCommand = getAndEatNextInputCommand;
// From gamepad or other input sources
var setNextInputCommand = function (c, setRunMode) {
    if (setRunMode === void 0) { setRunMode = false; }
    _nextInputCommand = c;
    if (setRunMode) {
        rogueRunMode_sidecar_1.rogueRunMode.setRunMode(c);
    }
};
exports.setNextInputCommand = setNextInputCommand;
var setNextInputCommandAndRun = function (c) {
    (0, exports.setNextInputCommand)(c, true);
};
exports.setNextInputCommandAndRun = setNextInputCommandAndRun;
var setNextInputCommandAndRunIfNotAlreadyRunning = function (c) {
    if (rogueRunMode_sidecar_1.rogueRunMode.getRunMode() === c) {
        return;
    }
    (0, exports.setNextInputCommandAndRun)(c);
};
exports.setNextInputCommandAndRunIfNotAlreadyRunning = setNextInputCommandAndRunIfNotAlreadyRunning;
var create = function () {
    rogueKeyboard_sidecar_1.rogueKeyboard.create();
    rogueMouse_sidecar_1.rogueMouse.create();
};
exports.create = create;
var update = function () {
    rogueGamepad_sidecar_1.rogueGamepad.updateGamepad();
    rogueMouse_sidecar_1.rogueMouse.update();
    if (rogueMouseAreas_sidecar_1.rogueMouseAreas.testAll()) {
        // Eat click
    }
    else {
        rogueMouseHandler_sidecar_1.rogueMouseHandler.update();
    }
};
exports.update = update;
